<template>
  <b-row>
    <b-col xl="12" md="12" sm="12">
      <transition name="slide">
      <b-card :header="caption" >
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="events" :fields="fields" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
          <template slot="title" slot-scope="data">
            <strong>{{data.item.title}}</strong>
          </template>
          <template slot="date" slot-scope="data">
            <strong>{{data.item.date}}</strong>
          </template>
          <template slot="hour" slot-scope="data">
            <strong>{{data.item.hour}}</strong>
          </template>
          <template slot="created" slot-scope="data">
            {{new Date(data.item.created).toGMTString()}}
          </template>
          <template slot="modified" slot-scope="data">
            {{new Date(data.item.modified).toGMTString()}}
          </template>
        </b-table>
        <nav>
          <b-pagination size="sm" :total-rows="getRowCount(events)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
          <b-row class="align-items-center">
            <b-col xl= "4" sm="6" md="4" class="mb-3 mb-xl-0" >
              <b-button v-on:click="addEventButton" block variant="primary">Add Event</b-button>
            </b-col>
        </b-row>
        </nav>
      </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import { db } from '@/config/devowqlo';
export default {
  name: 'Events',
  firebase: {
    events: db.ref('propertyEvents')
  },
  props: {
    caption: {
      type: String,
      default: 'Events'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      //items: teamsData.filter((team) => team.id < 10),
      // items: [],
      // items: this.$firebaseRefs.teams,
      // items: this.getTeams(),
      fields: [
        {key: 'title'},
        {key: 'date'},
        {key: 'hour'},
        {key: 'created'},
        {key: 'modified'},
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0
    }
  },
  methods: {
    getRowCount (events) {
      console.log(events)
      return events.length

    },
    eventLink (id) {
      return `events/${id}`
    },
    rowClicked (event) {
      const eventLink = this.eventLink(event['.key'])
      this.$router.push({path: eventLink})
      // :to="{ name: 'Edit', params: {id: item['.key']} }"
    },
    addEventButton () {
      this.$router.push({path: 'events/addevent'})
    }

  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
